/// <reference path="../../../../../../typings/index.d.ts" />
///<reference path="../../../../components/modal/modal.interface.ts"/>

module Meevo.Plugins.Reports {


    import IReportControl = Meevo.Model.IReportControl;

    interface IReportScope extends ng.IScope {
    }

    interface IModalScope extends ng.IScope {
        close: () => void;
        data: any[];
    }

    class MeevoReportDc090Component implements angular.IComponentController {

        static $inject = [
            '$translate',
            'meevo.components.modal.ModalService',
        ];

        public mainModel: Object;
        public parameterNames: string[];
        public securityAccess: any;
        public options: IReportControl;

        public currentMonth: any;
        public minStartDate: any;
        public minTOStartDate: any;
        public maxEndDate: any;
        public startDate: any;
        public minEndDate: any;
        public isNotValidDateRange: boolean ;

        public sortByData = [
            { label: 'LABEL_ACTIVE', value: 'Active' },
            { label: 'LABEL_EXPIRED', value: 'Expired' },
        ];

        constructor(private $translate: angular.translate.ITranslateService, protected modalService: Meevo.Components.Modal.IModalService) {
            //this sets the start date and end date ( to be 3 months after the start date)
            this.currentMonth = new Date(moment().startOf('month').format('L'));
            this.minStartDate = new Date(moment().startOf('month').format('L'));
            this.minEndDate = new Date(moment(this.minStartDate).add(2, 'M').endOf('month').format('L'));
        }

        nDateFromChange(fromDate: any) {
          this.startDate = new Date(moment(fromDate).startOf('month').format('L'));
          this.minEndDate = new Date(moment(this.startDate).add(2, 'M').endOf('month').format('L'));

          this.mainModel[this.parameterNames[4]] = this.minEndDate;

        }

        onChangeToDate(toStartDate: any, fromStartDate: any) {
            //This will evaluate the gap between startDate and EndDate. Then it will check if the length is greater than a quarter and will submit a warning prompting the user to adjust.

            var dateDiffInMonths = moment(new Date(fromStartDate)).diff(moment(new Date(toStartDate)), 'months', false);

            if (dateDiffInMonths > 3) {
                this.modalService.alert('LABEL_TIME_SPAN_NOT_GREATER_3_MONTHS', Meevo.Components.Modal.ModalTranslationModes.Translate);
                this.isNotValidDateRange = true;
            }
            else {
                this.isNotValidDateRange = false;
            }
        }

        $onInit() {
            // set default control values
        }
    }

    angular.module('meevo.plugins.reports')
        .component('meevoReportDc090Component', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/reports/components/dc090/meevo-report-dc090.component.html',
            controller: MeevoReportDc090Component,
            controllerAs: '$ctrl',
            bindings: {
                mainModel: '<',
                parameterNames: '<',
                securityAccess: '<',
                validationJson: '<',
                options: '<',
                disabled: '=?ngDisabled'
            }
        });
}